import { useState, useEffect } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { ChatBox } from "./ChatBox";
import { MessageCircle } from "lucide-react";

const API_URL = process.env.REACT_APP_BACKEND_URL || '';
const TOKEN_KEY = 'fruitCrush_token';

// Admin emails who can post in Updates channel
const ADMIN_EMAILS = [
  "karan.nanden@fxcvantage.com",
  "karan_371@hotmail.com",
  "admin@fruit-crush.com"
];
const ADMIN_USERNAMES = ["admin", "Admin", "karan"];

export function ChatModal({ isOpen, onClose }) {
  const [currentUser, setCurrentUser] = useState(null);
  
  // Fetch current user info
  useEffect(() => {
    const fetchCurrentUser = async () => {
      const token = localStorage.getItem(TOKEN_KEY);
      if (!token) return;
      
      try {
        const response = await fetch(`${API_URL}/api/auth/me`, {
          headers: { 'Authorization': `Bearer ${token}` }
        });
        
        if (response.ok) {
          const userData = await response.json();
          // Check if user is admin
          const isAdmin = ADMIN_EMAILS.includes(userData.email?.toLowerCase()) || 
                          ADMIN_USERNAMES.includes(userData.player_name);
          setCurrentUser({ ...userData, is_admin: isAdmin });
        }
      } catch (error) {
        console.error('Failed to fetch current user:', error);
      }
    };
    
    if (isOpen) {
      fetchCurrentUser();
    }
  }, [isOpen]);

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="max-w-2xl bg-gradient-to-br from-slate-900 to-slate-950 border-white/10 text-white p-0 overflow-hidden">
        <DialogHeader className="p-4 pb-0">
          <DialogTitle className="flex items-center gap-2 text-xl font-bold">
            <MessageCircle className="w-6 h-6 text-green-400" />
            <span className="bg-gradient-to-r from-green-400 to-teal-400 bg-clip-text text-transparent">
              Chat
            </span>
          </DialogTitle>
        </DialogHeader>
        
        <div className="px-4 pb-4">
          <ChatBox currentUser={currentUser} />
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default ChatModal;
